import React from "react";
import { Field, reduxForm } from "redux-form";
import { Modal } from "components";
import { Button, Input, Select, Checkbox } from "expano-components";
import { updateWarehouse } from "actions/warehouses";

import { ReactComponent as EditIcon } from "icons/edit.svg";
import { useMainList } from "components/MainList/context/provider";
import country_code_options from "utils/country_code_options";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;
const CheckField = (props) => <Checkbox {...props} />;
const ModalEditWarehouse = ({
  id,
  change,
  invalid,
  pristine,
  handleSubmit,
  handleClose,
  initialValues,
}) => {
  const { refetch } = useMainList();

  const onSubmit = async (values) => {
    try {
      await updateWarehouse(id, values);
      handleClose();
      refetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        icon: <EditIcon />,
        title: "Edycja",
      }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <button
            disabled={invalid || pristine}
            onClick={handleSubmit(onSubmit)}
            type="submit"
            className="btn btn-sm btn-green"
          >
            <span>Zapisz</span>
          </button>
        </>
      }
    >
      <form noValidate>
        <table className="modal-table">
          <tbody>
            <tr>
              <td>Nazwa</td>
              <td>
                <Field placeholder="Nazwa" name="name" component={InputField} />
              </td>
            </tr>
            <tr>
              <td>Erp ID</td>
              <td>
                <Field
                  placeholder="Erp ID"
                  name="erp_id"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Ulica</td>
              <td>
                <Field
                  placeholder="Ulica"
                  name="street"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Miasto</td>
              <td>
                <Field
                  placeholder="Miasto"
                  name="city"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Kod pocztowy</td>
              <td>
                <Field
                  placeholder="Kod pocztowy"
                  name="zip_code"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Kraj</td>
              <td>
                <Field
                  name="country_code"
                  component={SelectField}
                  handleChange={(value) => change("country_code", value)}
                  defaultValue={country_code_options.find(
                    ({ value }) => value === initialValues.country_code
                  )}
                  options={country_code_options}
                />
              </td>
            </tr>
            <tr>
              <td>Typ magazynu</td>
              <td>
                <div className="check-holder">
                  <Field
                    type="checkbox"
                    id="is_virtual"
                    name="is_virtual"
                    label="Magazyn wirtualny"
                    component={CheckField}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane!";
  }
  return errors;
};

export default reduxForm({
  form: "edit-rack-schema",
  validate,
  enableReinitialize: true,
})(ModalEditWarehouse);
